import { render, staticRenderFns } from "./M3_S45.vue?vue&type=template&id=5ae3c8a7&scoped=true"
import script from "./M3_S45.vue?vue&type=script&lang=js"
export * from "./M3_S45.vue?vue&type=script&lang=js"
import style0 from "./M3_S45.vue?vue&type=style&index=0&id=5ae3c8a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae3c8a7",
  null
  
)

export default component.exports